module.exports = __webpack_public_path__ + "img/fitness3.4268d134.png";